import A_CheckboxItem from '@/components/A_Atoms/A_CheckboxItem/A_CheckboxItem';
import styles from './W_PaymentActions.module.css';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import { useState } from 'react';
import W_PaymentOperationInfo from '../W_PaymentOperationInfo/W_PaymentOperationInfo';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface W_PaymentActionsProps {
  price?: number;
  remainingTime?: string;
  requestId?: number;
  isAmountValid?: boolean;
  isLoading?: boolean;
}

export default function W_PaymentActions({
  price,
  remainingTime,
  requestId,
  isAmountValid = true,
  isLoading = false,
}: W_PaymentActionsProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  const [isAccepted, setIsAccepted] = useState(false);

  const isButtonDisabled = !isAccepted || !isAmountValid || isLoading;

  return (
    <div className={styles.wrapper}>
      <A_CheckboxItem checked={isAccepted} onChange={setIsAccepted}>
        {t('payment.actions.agreePrefix')}{' '}
        <a href='/terms-of-use' className='text-p-5'>
          {t('payment.actions.terms')}
        </a>{' '}
        {t('payment.actions.brand')}
      </A_CheckboxItem>
      <A_Button
        variant='primary'
        size='large'
        type='submit'
        disabled={isButtonDisabled}
      >
        {isLoading
          ? t('payment.actions.processing')
          : `${t('payment.actions.pay')} ${price ? `${price} $` : ''}`}
      </A_Button>
      {remainingTime && requestId && (
        <W_PaymentOperationInfo
          remainingTime={remainingTime}
          requestId={requestId}
        />
      )}
    </div>
  );
}
